import { render, staticRenderFns } from "./DetailsSeries.vue?vue&type=template&id=092a838c&"
import script from "./DetailsSeries.vue?vue&type=script&lang=js&"
export * from "./DetailsSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports